import { logService } from '@nsftx/seven-client-retail-utils'
import {
  isMappedBetslipEvent,
  BETSLIP_EVENT_MAP,
  type BetslipEventHandlerMap,
  type SlipUpdateNotification
} from './types'
import { useNotificationEvent } from '../useNotificationEvent'
import { useTicketsStore } from '#src/stores/tickets/ticketsStore'
import { getBetslipActionByNotificationEvent, getBetslipLogDetails } from '#src/utils/betslipUtils'
import errorParser from '#src/utils/errorParser'

const LOG_PREFIX = '[useBetslipNotificationEvents]'

export const useBetslipNotificationEvents = () => {
  const registerBetslipEventHandlers = (handlers: BetslipEventHandlerMap) => {
    useNotificationEvent('ng::slip-update', (detail: SlipUpdateNotification) => {
      const slip = detail.content.slip
      const event = detail.content.activity
      const feBetslipId = slip.context.feBetslipId

      logService.debug(`${LOG_PREFIX} Slip update event received.`, {
        code: 'SGP_SLIP_UPDATE_EVENT_SUCCESS',
        feBetslipId,
        details: {
          event
        }
      })

      if (!isMappedBetslipEvent(event.currentState)) {
        return
      }

      const ticketAction = getBetslipActionByNotificationEvent(event.currentState)
      const { setAction, resolveTicket } = useTicketsStore()

      try {
        const mappedEvent = BETSLIP_EVENT_MAP[event.currentState]
        const eventHandler = handlers[mappedEvent]
        if (!eventHandler) {
          return
        }

        setAction(ticketAction)
        resolveTicket(slip)
        logService.info(`${LOG_PREFIX} Slip successfully resolved by socket.`, {
          code: 'SGP_SLIP_RESOLVE_SUCCESS',
          action: ticketAction,
          ...getBetslipLogDetails(slip)
        })
        eventHandler(slip)
      } catch (error) {
        logService.error(`${LOG_PREFIX} Slip resolve has failed.`, {
          ...errorParser.parseUpstream(error),
          code: 'SGP_SLIP_RESOLVE_ERROR',
          action: ticketAction,
          ...getBetslipLogDetails(slip)
        })
      }
    })
  }

  return {
    registerBetslipEventHandlers
  }
}
